import clsx from "clsx";

import { Tooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { getBackgroundColorClass } from "@features/product-analytics/metricsData";
import { formatting } from "@north-beam/nb-common";

export const EfficiencyIndex = ({
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  return (
    <div
      className={clsx(
        "px-2 text-right h-full flex items-center font-mono text-sm font-medium",
      )}
    >
      <Tooltip
        noInfoCircle
        className="w-full flex justify-end"
        overlayClassName="bg-[#010715] rounded-lg p-4"
        content={
          <div>
            <div className="text-white">
              <div className="text-[#F2F3F5] text-xs font-semibold uppercase">
                Relative Roas
              </div>
              <div className="h-[1px] bg-v2-primary my-2"></div>
              <div className="w-[400px] text-[#F2F3F5] text-sm font-normal mb-2">
                A score from 1 to 100 that measures how efficient advertising
                for this product is, based on revenue generated per spend,
                compared to all other products. A higher score indicates better
                advertising efficiency.
              </div>
              <div className="flex justify-between">
                <div className="text-[#F2F3F5] font-semibold text-sm">
                  ROAS:
                </div>
                <div className="text-[#F2F3F5] font-tt-commons-pro-mono text-sm font-normal">
                  {formatting.formatMultiplier(row.roas, {
                    precision: "approximate",
                  })}
                </div>
              </div>
              <div className="flex justify-between">
                <div className="text-[#F2F3F5] font-semibold text-sm">
                  Revenue:
                </div>
                <div className="text-[#F2F3F5] font-tt-commons-pro-mono text-sm font-normal">
                  {formatting.formatCurrency(row.rev, {
                    code: user.currencies.currentCurrency,
                  })}
                </div>
              </div>
              <div className="flex justify-between">
                <div className="text-[#F2F3F5] font-semibold text-sm">
                  Spend:
                </div>
                <div className="text-[#F2F3F5] font-tt-commons-pro-mono text-sm font-normal">
                  {formatting.formatCurrency(row.spend, {
                    code: user.currencies.currentCurrency,
                  })}
                </div>
              </div>
            </div>
          </div>
        }
      >
        <div
          className={clsx(
            "text-right w-[19px] h-[17px] font-tt-commons-pro-mono text-xs font-normal rounded flex justify-center items-center  px-[3px]",
            getBackgroundColorClass(row.cacPercentage),
          )}
        >
          {Math.trunc(row.roasPercentage)}
        </div>
      </Tooltip>
    </div>
  );
};
